import { render, staticRenderFns } from "./ElButtonRedagoti.vue?vue&type=template&id=774de955&scoped=true&"
import script from "./ElButtonRedagoti.vue?vue&type=script&lang=js&"
export * from "./ElButtonRedagoti.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonRedagoti.vue?vue&type=style&index=0&id=774de955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774de955",
  null
  
)

export default component.exports